// sr/utils/api/cleaner/readMessage.ts

import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { put } from "sr/utils/axios";

export const readMessage = async (data: {
  recipient_id: string;
  id?: string;
}) => {
  try {
    return await put<ApiResponse<[]>>(`/chatmessage/read`, data).then((res) => {
      if (res.success === true) {
        return res;
      } else {
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
  }
};
